
import { Map, Record } from 'immutable';
import { EmailTempListResponseModel } from '../emailtemp-model/emailtemplist.response.model';

export interface EmailTempState extends Map<string, any> {
  newEmailTemp: any;
  updateEmailTemp: any;
  emailTempList: Array<EmailTempListResponseModel>;
  emailTempPagination: any;
  emailTempDelete: any;

  listLoading: boolean;
  listLoaded: boolean;
  listFailed: boolean;

  countLoading: boolean;
  countLoaded: boolean;
  countFailed: boolean;

  addLoading: boolean;
  addLoaded: boolean;
  addFailed: boolean;

  updatLoading: boolean;
  updatLoaded: boolean;
  updatFailed: boolean;

  updateLoading: boolean;
  updateLoaded: boolean;
  updateFailed: boolean;

  deleteLoading: boolean;
  deleteLoaded: boolean;
  deleteFailed: boolean;
}

export const EmailTempRecordState = Record({
  newEmailTemp: {},
  updateEmailTemp: {},
  emailTempList: {},
  emailTempPagination: {},
  emailTempDelete: {},

  listLoading: false,
  listLoaded: false,
  listFailed: false,

  countLoading: false,
  countLoaded: false,
  countFailed: false,

  addLoading: false,
  addLoaded: false,
  addFailed: false,

  updatLoading: false,
  updatLoaded: false,
  updatFailed: false,

  updateLoading: false,
  updateLoaded: false,
  updateFailed: false,

  deleteLoading: false,
  deleteLoaded: false,
  deleteFailed: false
});
